import { isPermission } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import { defaultPermissions, type PermissionValues } from '../types/common';

// Permissions arrive from the API as plain strings, and the backend can add one
// the frontend has no slot for.
const permissionsArrayToObject = (
  permissions?: string[] | null,
): PermissionValues => {
  const values = { ...defaultPermissions };
  permissions?.forEach((permission) => {
    if (isPermission(permission)) {
      values[permission] = true;
    }
  });
  return values;
};

export default permissionsArrayToObject;
